import axios from 'axios';

const API = axios.create({
  baseURL: 'https://abhyasakriti.jyothyit.ac.in',
});

// ── Request interceptor: attach token to every request ──────────────────────
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || localStorage.getItem('student_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Response interceptor: handle 401s globally ───────────────────────────────
API.interceptors.response.use(
  // Any 2xx response — just pass it through
  (response) => response,

  // Any error response
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';

    // If 401 on any route EXCEPT login itself — session expired
    if (status === 401 && !requestUrl.includes('/api/auth/login') && !requestUrl.includes('/api/students/login')) {
      // Clear everything
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('student_token');
      localStorage.removeItem('student');

      // Redirect to correct login page
      const isStudentRoute = window.location.pathname.startsWith('/student');
      window.location.href = isStudentRoute ? '/student/login' : '/';
    }

    return Promise.reject(error);
  }
);

export default API;